import { LoanSummary, AgreementCheckbox } from "../../components"
import { useAppState, useConsumerCalcs } from "../../hooks"
import { ConsumerResourceLinks } from "./consumer-resource-links"
import { SubformProps } from "."

export const SubmitLoanApplication = ({
  formData,
  onSubmit,
  update,
  onError
}: Partial<SubformProps>) => {
  const { tenant } = useAppState()
  const { loanTermInYears, rate, amortization } = useConsumerCalcs(formData)
  const { incentive } = formData

  return <>
    <div className="sa-summary my-4">
      <p>
        You're applying for a {loanTermInYears}-year loan ({formData.loanDurationMonths} months)
        at a {incentive ? `${incentive.nonIncentiveRate}% before incentives**` : `${rate}%`} interest
        rate. Here's a quick summary of your loan details:
      </p>
      <LoanSummary
        formData={formData}
        incentive={formData.incentive}
        showApr={formData.projectType === 'residential' && !formData.incentive}
        amortization={amortization}
      />
    </div>
    <ConsumerResourceLinks formData={formData} update={update} />
    {formData.incentive ? <div className="text-small mb-3 fst-italic">
      **With qualifying incentive. Incentive terms can be found <a target="_blank" href={formData.incentive.termsUrl}>here</a>.
    </div> : null}
    <AgreementCheckbox
      formData={formData}
      update={update}
      name="agreesToProceedWithHardCreditInquiry"
    >
      I understand that by submitting my loan application, this will
      result in a hard credit inquiry, which can impact my credit score.
    </AgreementCheckbox>
    <AgreementCheckbox
      formData={formData}
      update={update}
      name="agreesToWarningAgainstUsingOtherFinancing"
    >
      I understand that {tenant.config.name} clean energy loans are not to be used alongside any other
      financing products, such as a lease or power purchase agreement (PPA). Using funds for any purpose
      other than the purchase and installation of clean energy improvements to be <b>owned</b> by the customer 
      will cause the loan to default and trigger remedies, including but not limited to, acceleration of loan repayment.
    </AgreementCheckbox>
    <AgreementCheckbox
      formData={formData}
      update={update}
      name="agreesTo6MonthNoPaymentPeriod"
    >
      I understand no payments are required during the first six months and that interest
      will continue to accrue and be added to my loan balance during this period.
    </AgreementCheckbox>
    <p>
      By submitting your application request you certify that complete and accurate responses have
      been provided for all questions on the application, and agree to
      allow {tenant.config.name} to verify your personal information and check your credit.
    </p>
    <div className="buttons text-start">
      <button
        disabled={[
          formData.agreesToProceedWithHardCreditInquiry?.agrees,
          formData.attestConsumerResourceUnderstanding?.agrees,
          formData.agreesToWarningAgainstUsingOtherFinancing?.agrees,
          formData.agreesTo6MonthNoPaymentPeriod?.agrees
        ].some(v => v !== true)}
        type="button"
        className="btn btn-primary"
        onClick={() => onSubmit()}
      >Submit Loan Application</button>
      {/* <RequestChanges
        formData={formData}
        update={update}
        onError={onError}
      /> */}
      {process.env.REACT_APP_NODE_ENV === 'test' ? <>
        <button
          disabled={!formData.attestConsumerResourceUnderstanding?.agrees}
          type="button"
          className="btn btn-secondary"
          onClick={() => onSubmit({ test: true })}
        >Test Submit</button>
      </> : null}
    </div>
    {process.env.REACT_APP_NODE_ENV === 'test' ? <div className="alert alert-secondary mt-3">
      Clicking "Test Submit" will pull DIT, send docs, and simulate the user experience,
      but will NOT actually submit to the lender; e.g., account numbers will be faked.
    </div> : null}
  </>
}

